import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Validators, FormGroup, FormBuilder, NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { AssistantService } from 'src/app/services/assistant.service';
import { ClientService } from 'src/app/services/client.service';
import { DriverService } from 'src/app/services/driver.service';
import { UnitService } from 'src/app/services/unit.service';
import { UtilsService } from 'src/app/services/utils.service';
import { Location } from '@angular/common';

import { forkJoin, Subject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { OrderService } from 'src/app/services/order.service';
import { Router } from '@angular/router';
import { TrailerService } from 'src/app/services/trailer.service';
import { ExpenseService } from 'src/app/services/expense.service';

declare const $: any;
declare const google: any;

@Component({
  selector: 'app-order-changed-unit',
  templateUrl: './order-changed-unit.component.html',
  styleUrls: ['./order-changed-unit.component.css']
})
export class OrderChangedUnitComponent {


  constructor(
    private fb: FormBuilder,
    private utils: UtilsService,
    private spinner: NgxSpinnerService,
    private apiClient: ClientService,
    private apiUnit: UnitService,
    private apiAssitant: AssistantService,
    private apiDriver: DriverService,
    private apiService: OrderService,
    private apiTrailer: TrailerService,
    private location: Location,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private expenseService: ExpenseService
  ) {
    // Inicializar el formulario inmediatamente para evitar errores de detección de cambios
    this.initializeForm();
  }

  serviceForm!: FormGroup
  formModelData: any = {
    client: "",
    origin: "",
    destination: "",
    unit: "",
    driver: "",
    assistant: "",
    requires_trailer: false,
    trailer_id: "",
    bands: "",
    roller_skates: "",
    beach: "",
    devils: "",
    mats: "",
    cartons: "",
    charging_hour: "",
    upload_date: "",
    download_date: "",
    download_time: "",
    assistants: [],
    address: [],
    unified: null,
    observation: "",
    departure_date: "",
    departure_time: ""
  }
  clientSelected: any = {
    destination_address: [],
    origin_address: []
  }

  text_loading = "Cargando Información"

  isUnified = false

  originalUnitId: any = null
  originalDriverId: any = null
  eligibleGroupServices: any[] = []
  selectedGroupServiceIds: number[] = []
  showGroupModal = false
  private groupCheck$ = new Subject<{ unitId: number, driverId: number }>()

  safety_equipment: any = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]

  dataClient: any = []
  dataDriver: any = []
  dataAssistant: any = []
  dataUnit: any = []
  dataTrailers: any = []
  submitted: boolean = false;

  // Método auxiliar para asegurar que submitted siempre sea booleano
  get isSubmitted(): boolean {
    return this.submitted ?? false;
  }

  dataValidUnified: any = {}

  changed_label_origin = false
  changed_label_destination = false

  originPlaceSelected = false
  destinationPlaceSelected = false
  originPlaceId: string | null = null
  destinationPlaceId: string | null = null

  private getPlaceComponent(place: any, type: string, nameType: 'long_name' | 'short_name' = 'long_name'): string | null {
    const comps = place?.address_components || []
    const found = comps.find((c: any) => (c?.types || []).includes(type))
    return found ? (found[nameType] || null) : null
  }

  private mapPlaceToAddressData(place: any) {
    const street = this.getPlaceComponent(place, 'route')
    const streetNumber = this.getPlaceComponent(place, 'street_number')
    const interior = this.getPlaceComponent(place, 'subpremise')
    const neighborhood = this.getPlaceComponent(place, 'sublocality_level_1') || this.getPlaceComponent(place, 'neighborhood')
    const locality = this.getPlaceComponent(place, 'locality')
    const municipality = this.getPlaceComponent(place, 'administrative_area_level_2')
    const state = this.getPlaceComponent(place, 'administrative_area_level_1', 'short_name')
    const country = this.getPlaceComponent(place, 'country', 'short_name')
    const postalCode = this.getPlaceComponent(place, 'postal_code')
    const reference = place?.name || null

    const lat = typeof place?.geometry?.location?.lat === 'function' ? place.geometry.location.lat() : (place?.geometry?.location?.lat ?? null)
    const lng = typeof place?.geometry?.location?.lng === 'function' ? place.geometry.location.lng() : (place?.geometry?.location?.lng ?? null)

    return {
      place_id: place?.place_id || null,
      formatted_address: place?.formatted_address || null,
      coordinates: { lat, lng },
      components: {
        Calle: street,
        NumeroExterior: streetNumber,
        NumeroInterior: interior,
        Colonia: neighborhood,
        Localidad: locality,
        Referencia: reference,
        Municipio: municipality,
        Estado: state,
        Pais: country,
        CodigoPostal: postalCode
      }
    }
  }

  dataUser: any = {}

  options_autocomple = {
    fields: ["address_components", "formatted_address", "geometry", "icon", "name"],
    strictBounds: false,
    types: ['address']
  };

  autocomple_origin() {
    this.changed_label_origin = !this.changed_label_origin
    if (this.changed_label_origin) {
      this.originPlaceSelected = false
      this.originPlaceId = null
      setTimeout(() => {
        const input_origin = document.getElementById("origin_address") as HTMLInputElement;
        const autocomplete_ori = new google.maps.places.Autocomplete(input_origin, this.options_autocomple);
        google.maps.event.addListener(autocomplete_ori, 'place_changed', () => {
          var place = autocomplete_ori.getPlace();
          this.formModelData.origin = place.formatted_address
          this.originPlaceSelected = true
          this.originPlaceId = place?.place_id || null

          const mapped = this.mapPlaceToAddressData(place)
          this.formModelData.origin_place_id = mapped.place_id
          this.formModelData.origin_components = mapped.components
          this.formModelData.origin_lat = mapped.coordinates.lat
          this.formModelData.origin_lng = mapped.coordinates.lng
        })
      }, 500);
    }
  }

  autocomple_destination() {
    this.changed_label_destination = !this.changed_label_destination
    if (this.changed_label_destination) {
      this.destinationPlaceSelected = false
      this.destinationPlaceId = null
      setTimeout(() => {
        const input_dest = document.getElementById("destination_address") as HTMLInputElement;
        const autocomplete_dest = new google.maps.places.Autocomplete(input_dest, this.options_autocomple);
        google.maps.event.addListener(autocomplete_dest, 'place_changed', () => {
          var place = autocomplete_dest.getPlace();
          this.formModelData.destination = place.formatted_address
          this.destinationPlaceSelected = true
          this.destinationPlaceId = place?.place_id || null

          const mapped = this.mapPlaceToAddressData(place)
          this.formModelData.destination_place_id = mapped.place_id
          this.formModelData.destination_components = mapped.components
          this.formModelData.destination_lat = mapped.coordinates.lat
          this.formModelData.destination_lng = mapped.coordinates.lng
        })
      }, 500);

    }
  }

  onMainAddressInputChanged(type: 'origin' | 'destination') {
    if (type === 'origin') {
      this.originPlaceSelected = false
      this.originPlaceId = null
      this.formModelData.origin_place_id = null
      this.formModelData.origin_components = null
      this.formModelData.origin_lat = null
      this.formModelData.origin_lng = null
    } else {
      this.destinationPlaceSelected = false
      this.destinationPlaceId = null
      this.formModelData.destination_place_id = null
      this.formModelData.destination_components = null
      this.formModelData.destination_lat = null
      this.formModelData.destination_lng = null
    }
  }

  onMultiAddressInputChanged(item: any, type: 'origin' | 'destination') {
    if (!item) return
    if (type === 'origin') {
      item.origin_place_selected = false
      item.origin_place_id = null
      item.origin_components = null
      item.origin_lat = null
      item.origin_lng = null
    } else {
      item.destination_place_selected = false
      item.destination_place_id = null
      item.destination_components = null
      item.destination_lat = null
      item.destination_lng = null
    }
  }

  private validateGoogleAddressSelections(): boolean {
    if (this.changed_label_origin && !this.originPlaceSelected) {
      this.utils.alertSwal({
        title: "Advertencia",
        text: "Debes seleccionar una dirección de la lista de Google para el Origen.",
        icon: "warning"
      })
      return false
    }

    if (this.changed_label_destination && !this.destinationPlaceSelected) {
      this.utils.alertSwal({
        title: "Advertencia",
        text: "Debes seleccionar una dirección de la lista de Google para el Destino.",
        icon: "warning"
      })
      return false
    }

    const invalidExtra = (this.formModelData.address || []).find((addr: any) => {
      if (addr?.input_origin && !addr?.origin_place_selected) return true
      if (addr?.input_destination && !addr?.destination_place_selected) return true
      return false
    })

    if (invalidExtra) {
      this.utils.alertSwal({
        title: "Advertencia",
        text: "Debes seleccionar una dirección de la lista de Google en las direcciones adicionales.",
        icon: "warning"
      })
      return false
    }

    return true
  }

  private initializeForm(): void {
    this.serviceForm = this.fb.group({
      client: [{disabled: true, value:''}, Validators.required],
      origin: [{disabled: false, value: ''}, Validators.required],
      destination: [{disabled: false, value: ''}],
      unit: [{disabled: false, value: ''}, Validators.required],
      driver: [{disabled: false, value: ''}, Validators.required],
      assistant: [{disabled: false, value: ''}, Validators.required],
      requires_trailer: [false],
      trailer_id: [''],
      charging_hour: [{disabled: false, value: ''}, Validators.required],
      upload_date: [{disabled: false, value: ''}, Validators.required],
      download_date: [{disabled: false, value: ''}],
      download_time: [{disabled: false, value: ''}],
      departure_date: [{disabled: false, value: ''}, Validators.required],
      departure_time: [{disabled: false, value: ''}, Validators.required],
      bands: [{disabled: true, value: ''}, Validators.required],
      roller_skates: [{disabled: true, value: ''}, Validators.required],
      beach: [{disabled: true, value: ''}, Validators.required],
      devils: [{disabled: true, value: ''}, Validators.required],
      mats: [{disabled: true, value: ''}, Validators.required],
      cartons: [{disabled: true, value: ''}, Validators.required],
      observation: [{disabled: false, value: ''}]
    });
  }

  ngOnInit(): void {

    this.groupCheck$.pipe(
      switchMap(({ unitId, driverId }) =>
        this.expenseService.getEligibleServicesByUnitDriver(unitId, driverId)
      )
    ).subscribe({
      next: (res) => {
        if (res.data && res.data.length > 0) {
          this.eligibleGroupServices = [...res.data];
          this.showGroupModal = true;
        } else {
          this.eligibleGroupServices = [];
          this.selectedGroupServiceIds = [];
          this.showGroupModal = false;
        }
      },
      error: () => {}
    });

    this.spinner.show()

    this.dataUser = this.utils.getDataUser()

    const servicio1$ = this.apiAssitant.getInfo();
    const servicio2$ = this.apiClient.getInfo();
    const servicio3$ = this.apiDriver.getInfo();
    const servicio4$ = this.apiUnit.getInfo();
    const servicio5$ = this.apiTrailer.getCombo();

    forkJoin([servicio1$, servicio2$, servicio3$, servicio4$, servicio5$]).subscribe(([resp1, resp2, resp3, resp4, resp5]) => {
      this.dataAssistant = resp1
      this.dataClient = resp2
      this.dataDriver = resp3
      this.dataUnit = resp4
      this.dataTrailers = resp5
      
      // Llamar a getData() para cargar los datos del formulario
      this.getData()
      
      // Forzar detección de cambios después de cargar los datos
      this.cdr.detectChanges()
      
      this.spinner.hide()
    })

    
    // El formulario ya está inicializado en el constructor
    this.autocomple_origin()
    this.autocomple_destination()

  }


  get registerFormControl() {
    return this.serviceForm.controls;
  }

  // Getter seguro para acceder a los controles del formulario
  get fc() {
    return this.serviceForm?.controls || {} as any;
  }

  getData(){

    let da:any = this.location.getState()
    
    // Actualizar formModelData de manera segura con valores por defecto
    Object.assign(this.formModelData, {
      id: da.id,
      client: da.client_id,
      origin: da.origin_address,
      destination: da.destination_address,
      unit: da.unit_id,
      driver: da.driver_id,
      assistant: da.assistant_id,
      requires_trailer: da.requires_trailer !== undefined ? da.requires_trailer : false,
      trailer_id: da.trailer_id !== undefined ? da.trailer_id : '',
      bands: da.bands,
      roller_skates: da.roller_skates,
      beach: da.beach,
      devils: da.devils,
      mats: da.mats,
      cartons: da.cartons,
      charging_hour: da.charging_hour,
      upload_date: da.upload_date,
      download_date: da.download_date,
      download_time: da.download_time,
      assistants: da.assistants || [],
      observation: da.observation,
      departure_date: da.departure_date,
      departure_time: da.departure_time,
      // Preserve existing components if not changed
      origin_components: da.origin_components || null,
      destination_components: da.destination_components || null,
      origin_place_id: da.origin_place_id || null,
      destination_place_id: da.destination_place_id || null,
      origin_lat: da.origin_lat || null,
      origin_lng: da.origin_lng || null,
      destination_lat: da.destination_lat || null,
      destination_lng: da.destination_lng || null
    })
    
    // Actualizar el formulario con patchValue para evitar NG0100
    if (this.serviceForm) {
      this.serviceForm.patchValue({
        client: da.client_id,
        origin: da.origin_address,
        destination: da.destination_address,
        unit: da.unit_id,
        driver: da.driver_id,
        assistant: da.assistant_id,
        requires_trailer: da.requires_trailer || false,
        trailer_id: da.trailer_id || '',
        bands: da.bands,
        roller_skates: da.roller_skates,
        beach: da.beach,
        devils: da.devils,
        mats: da.mats,
        cartons: da.cartons,
        charging_hour: da.charging_hour,
        upload_date: da.upload_date,
        download_date: da.download_date,
        download_time: da.download_time,
        departure_date: da.departure_date,
        departure_time: da.departure_time,
        observation: da.observation
      }, { emitEvent: false })
    }
    
    this.onSelectChange(da.client_id)
    
    // Aplicar validación de configuración de unidad si hay unidad seleccionada
    if (da.unit_id) {
      this.setTrailerRequirement(da.unit_id)
    }
    
    this.originPlaceSelected = true
    this.destinationPlaceSelected = true

    // Guardar valores originales para detectar cambios posteriores
    this.originalUnitId = da.unit_id
    this.originalDriverId = da.driver_id

  }
  resetFormModel() {
    this.formModelData = {
      client: "",
      origin: "",
      destination: "",
      unit: "",
      driver: "",
      assistant: "",
      requires_trailer: false,
      trailer_id: "",
      bands: "",
      roller_skates: "",
      beach: "",
      devils: "",
      mats: "",
      cartons: "",
      charging_hour: "",
      upload_date: "",
      download_date: "",
      download_time: "",
      departure_date: "",
      departure_time: "",
      assistants: [],
      address: [],
      unified: null,
      observation: ''
    }
  }

  openModalConfirm(){
    $("#modalConfirm").modal("show")
  }

  addService() {

    $("#modalConfirm").modal("hide")
    this.submitted = true

    let validation: any = this.formModelData.assistants.length > 0 ? this.formModelData.assistants.filter((resp: any) => {
      if (resp.assistant_id == '') {
        return resp
      }
    }) : []

    if (validation.length) {
      this.utils.alertSwal({ title: "Advertencia", text: "Verifique que la información se encuentre completa.", icon: "warning" })
      return
    }

    if (!this.validateGoogleAddressSelections()) {
      return
    }
    if (this.serviceForm.valid) {
      this.spinner.show()
      this.text_loading = "Cambiando unidad..."
      this.formModelData.user_id = this.dataUser.id
      
      this.apiService.updateUnit(this.formModelData).subscribe((resp: any) => {
        const serviceId = this.formModelData.id
        if (serviceId && this.selectedGroupServiceIds.length > 0) {
          this.expenseService.createSharedGroup(+serviceId, this.selectedGroupServiceIds).subscribe()
        }
        this.selectedGroupServiceIds = []
        this.showGroupModal = false
        this.spinner.hide()
        this.utils.alertSwal({ title: "Exitoso", text: resp.msg, icon: "success" })
        this.router.navigateByUrl("/service/list")
      }, (error) => {
        this.utils.alertSwal({ title: "Error!", text: "Se ha presentado un error al crear el servicio", icon: "error" })
      })
    } else {
      this.utils.alertSwal({ title: "Advertencia", text: "Verifique que la información se encuentre completa.", icon: "warning" })
    }

  }
  changedValidUnified(event: any) {
    this.spinner.show()
    // Resetear selección de grupo si cambia la unidad
    this.selectedGroupServiceIds = []
    this.showGroupModal = false
    this.apiService.validUnified({ unit: event.target.value, destination: this.formModelData.destination }).subscribe((resp: any) => {
      if (resp.data != null && Object.keys(resp.data).length) {
        $("#modalValidUnified").modal("show")
        this.dataValidUnified = resp.data
        this.formModelData.assistant = resp.data.assistant_id
        this.formModelData.driver = resp.data.driver_id
        this.formModelData.unified = resp.data.id
      } else {
        this.isUnified = false
        this.dataValidUnified = {}
        this.formModelData.assistant_id = ""
        this.formModelData.driver = ""
        this.formModelData.unified = ""
      }
      this.spinner.hide()
      // Solo verificar grupo si la unidad cambió respecto al valor original
      const unitChanged = String(event.target.value) !== String(this.originalUnitId)
      const driverId = this.formModelData.driver
      if (unitChanged && driverId && event.target.value) {
        this.checkEligibleServicesForGroup(event.target.value, driverId)
      }
    }, (error) => {
      this.spinner.hide()
      alert("Se ha presentado un error al validar la informacion")
    })

    // Set trailer requirement based on unit configuration
    this.setTrailerRequirement(event.target.value);
  }

  changedDriver(event: any): void {
    const newDriverId = event.target.value
    this.selectedGroupServiceIds = []
    this.showGroupModal = false
    // Solo verificar grupo si el operador cambió respecto al valor original
    const driverChanged = String(newDriverId) !== String(this.originalDriverId)
    if (driverChanged && newDriverId && this.formModelData.unit) {
      this.checkEligibleServicesForGroup(this.formModelData.unit, newDriverId)
    }
  }

  checkEligibleServicesForGroup(unitId: any, driverId: any): void {
    this.showGroupModal = false;
    this.groupCheck$.next({ unitId: +unitId, driverId: +driverId });
  }

  onGroupServicesSelected(serviceIds: number[]): void {
    this.selectedGroupServiceIds = serviceIds
    this.showGroupModal = false
  }

  onGroupModalClosed(): void {
    this.selectedGroupServiceIds = []
    this.showGroupModal = false
  }

  private setTrailerRequirement(unitId: string) {
    const selectedUnit = this.dataUnit.find((unit: any) => unit.id == unitId);
    if (selectedUnit && selectedUnit.configuration_code) {
      const configCode = selectedUnit.configuration_code.toUpperCase();
      // Units that require trailer: C2R2, C3R2, T3S2R4
      const requiresTrailer = ['C2R2', 'C3R2', 'T3S2R4'].includes(configCode);
      this.formModelData.requires_trailer = requiresTrailer;
      
      // Clear trailer selection if trailer is no longer required
      if (!requiresTrailer) {
        this.formModelData.trailer_id = '';
      }
    }
  }

  getUnitConfigurationCode(): string {
    const selectedUnit = this.dataUnit.find((unit: any) => unit.id == this.formModelData.unit);
    return selectedUnit ? selectedUnit.configuration_code || 'N/A' : 'N/A';
  }

  clickModalValidUnified(event: any) {
    if (event == true) {
      this.isUnified = true
    } else {
      this.isUnified = false
      this.formModelData.assistant = ""
      this.formModelData.driver = ""
      this.formModelData.unified = ""
    }
    $("#modalValidUnified").modal("hide")
  }

  onSelectChange(event: any) {

    this.clientSelected = { origin_address: [], destination_address: [] }
    const selectedValue = event

    const found = this.dataClient.find((resp: any) => resp.id == selectedValue)
    if (found) {
      this.clientSelected = {
        ...found,
        origin_address:      found.origin_address      ?? [],
        destination_address: found.destination_address ?? [],
      }
    }
  }
  addAuxAssistant() {
    this.formModelData.assistants.push({ assistant_id: '' })
  }

  deleteAssitant(index: any) {
    this.formModelData.assistants.splice(index, 1)
  }

  addAddess() {
    this.formModelData.address.push({
      origin: '',
      destination: '',
      input_origin: false,
      input_destination: false,
      origin_place_selected: false,
      destination_place_selected: false,
      origin_place_id: null,
      destination_place_id: null,
      origin_components: null,
      destination_components: null,
      origin_lat: null,
      origin_lng: null,
      destination_lat: null,
      destination_lng: null
    })
  }

  deleteAddress(index: any) {
    this.formModelData.address.splice(index, 1)
  }

  autocomple_origin_mult(index: number, item: any) {
    item.input_origin = !item.input_origin
    if (item.input_origin) {
      item.origin_place_selected = false
      item.origin_place_id = null
      setTimeout(() => {
        const input_origin = document.getElementById("origin_address_" + index) as HTMLInputElement;
        const autocomplete_ori = new google.maps.places.Autocomplete(input_origin, this.options_autocomple);
        google.maps.event.addListener(autocomplete_ori, 'place_changed', () => {
          var place = autocomplete_ori.getPlace();
          item.origin = place.formatted_address
          item.origin_place_selected = true
          item.origin_place_id = place?.place_id || null

          const mapped = this.mapPlaceToAddressData(place)
          item.origin_place_id = mapped.place_id
          item.origin_components = mapped.components
          item.origin_lat = mapped.coordinates.lat
          item.origin_lng = mapped.coordinates.lng
        })
      }, 500);
    }
  }

  autocomple_destination_mult(index: number, item: any) {
    item.input_destination = !item.input_destination
    if (item.input_destination) {
      item.destination_place_selected = false
      item.destination_place_id = null
      setTimeout(() => {
        const input_origin = document.getElementById("destination_address_" + index) as HTMLInputElement;
        const autocomplete_ori = new google.maps.places.Autocomplete(input_origin, this.options_autocomple);
        google.maps.event.addListener(autocomplete_ori, 'place_changed', () => {
          var place = autocomplete_ori.getPlace();
          item.destination = place.formatted_address
          item.destination_place_selected = true
          item.destination_place_id = place?.place_id || null

          const mapped = this.mapPlaceToAddressData(place)
          item.destination_place_id = mapped.place_id
          item.destination_components = mapped.components
          item.destination_lat = mapped.coordinates.lat
          item.destination_lng = mapped.coordinates.lng
        })
      }, 500);
    }
  }


}
